import { createContext, useContext } from "react";
import { useAppVersion } from "./components/hooks/useAppVersion";

const AppVersionContext = createContext(null);

export const AppVersionProvider = ({ children }) => {
  const appVersion = useAppVersion();

  return (
    <AppVersionContext.Provider value={appVersion}>
      {children}
    </AppVersionContext.Provider>
  );
};

export const useAppVersionContext = () => {
  const context = useContext(AppVersionContext);

  if (!context) {
    throw new Error(
      "useAppVersionContext debe usarse dentro de AppVersionProvider",
    );
  }

  return context;
};
